
export class K12NewyearinfoSetupWizardProgressBarContext {
    constructor() {

    }
}
